export default {
    "data": {
        "h5": {
            "section": [
                { url: "https://s20.lgstatic.com/growth/activity/20220316/1647398990348.png", type: "img" },
                { url: "https://s20.lgstatic.com/growth/activity/20220120/1642666212417.jpg", type: "img" },
                { url: "https://s20.lgstatic.com/growth/activity/20210923/1632364836090.png", type: "img" },
                { url: "https://s21.lgstatic.com/growth/activity/20210923/1632365041683.png", type: "btn" },
                { url: "https://s20.lgstatic.com/growth/activity/20210923/1632365093680.png", type: "img" },
                { url: "https://s21.lgstatic.com/growth/activity/20210923/1632365179072.png", type: "img" },
                { url: "https://s21.lgstatic.com/growth/activity/20210923/1632365257252.png", type: "btn" },
                { url: "https://s20.lgstatic.com/growth/activity/20210923/1632365371128.png", type: "img" },
                { url: "https://s20.lgstatic.com/growth/activity/20210923/1632365412375.png", type: "tab" },
                { url: "https://s20.lgstatic.com/growth/activity/20210923/1632366959627.png", type: "btn", customize: true },
                { url: "https://s21.lgstatic.com/growth/activity/20210929/1632884329722.png", type: "swiper", dataType: '1' },
                { url: "https://s20.lgstatic.com/growth/activity/20210923/1632366689331.png", type: "btn", customize: true },
                { url: "https://s20.lgstatic.com/growth/activity/20210923/1632367393327.png", type: "img" },
                { url: "https://s20.lgstatic.com/growth/activity/20210923/1632379893111.png", type: "swiper", dataType: '2' },
                // { url: "https://s20.lgstatic.com/growth/activity/20210923/1632368414709.png", type: "img" },
                { url: "https://s21.lgstatic.com/growth/activity/20210923/1632368530147.png", type: "img" },
                { url: "https://s20.lgstatic.com/growth/activity/20210923/1632368554028.png", type: "img" },
                { url: "https://s20.lgstatic.com/growth/activity/20210923/1632368601182.png", type: "img" },
                { url: "https://s20.lgstatic.com/growth/activity/20210923/1632368674086.png", type: "btn" },
                { url: "https://s21.lgstatic.com/growth/activity/20210923/1632368739637.png", type: "img" },
                // { url: "https://s21.lgstatic.com/growth/activity/20210923/1632368768023.png", type: "img" },
                { url: "https://s21.lgstatic.com/growth/activity/20220316/1647399094146.png", type: "img" },
            ],
            "footerImg": "https://s21.lgstatic.com/growth/activity/20210923/1632368848485.png",
            "swiperList1": [
                "https://s20.lgstatic.com/growth/activity/20210923/1632367240260.png",
                "https://s20.lgstatic.com/growth/activity/20210923/1632367253859.png",
                "https://s21.lgstatic.com/growth/activity/20210923/1632367268290.png",
            ],
            "swiperList2": [
                "https://s21.lgstatic.com/growth/activity/20210310/1615362717360.png",
                "https://s21.lgstatic.com/growth/activity/20210310/1615362740823.png"
            ],

        },
        "pc": {
            "imgObj": {
                "top": "https://s20.lgstatic.com/growth/activity/20211020/1634718101728.png",
                "section1": "https://s21.lgstatic.com/growth/activity/20210916/1631777323462.png",
                "section2": "https://s21.lgstatic.com/growth/activity/20210916/1631777336297.png",
                "section3": "https://s20.lgstatic.com/growth/activity/20210916/1631778356937.png",
                "section4": "https://s21.lgstatic.com/growth/activity/20210916/1631782003107.png",
                "section5": "https://s21.lgstatic.com/growth/activity/20210916/1631781995927.png",
                "btn_stage": "https://s21.lgstatic.com/growth/activity/20210916/1631778653597.png",
                "btn1": "https://s20.lgstatic.com/growth/activity/20210916/1631779326202.png",
                "logo": "https://s20.lgstatic.com/growth/activity/20210916/1631780433790.png",
                "footer": "https://s20.lgstatic.com/growth/activity/20210916/1631781988116.png",
            },
            "imgList": [
                "https://s20.lgstatic.com/growth/activity/20210916/1631774961978.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631774969388.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631774975783.png",
                "https://s20.lgstatic.com/growth/activity/20210916/1631778024551.png",
            ],
            "imgList1": [
                "https://s21.lgstatic.com/growth/activity/20210916/1631779642120.png",
                "https://s20.lgstatic.com/growth/activity/20211126/1637915707850.jpg?x-oss-process=style/80",
                "https://s20.lgstatic.com/growth/activity/20210916/1631779656394.png",
            ],
            "swiperList": [
                "https://s21.lgstatic.com/growth/activity/20210916/1631774816400.png",
                "https://s20.lgstatic.com/growth/activity/20210916/1631774823928.png",
            ],
            "swiperList1": [
                "https://s20.lgstatic.com/growth/activity/20210916/1631775063257.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631775070977.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631775077345.png",
            ],
            "swiperList2": [
                "https://s20.lgstatic.com/growth/activity/20210916/1631779015030.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779091541.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779100203.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779106757.png",
            ],
            "swiperList3": [
                "https://s21.lgstatic.com/growth/activity/20210916/1631779831927.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779838447.png ",
                "https://s20.lgstatic.com/growth/activity/20210916/1631779859778.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779866936.png",
                "https://s20.lgstatic.com/growth/activity/20210916/1631779874015.png"
            ]
        },
        "tabList": [
            { "stage": "课程体系" },
            { "stage": "实战项目" },
            { "stage": "就业服务" },
            // { "stage": "私教模式" },
            // { "stage": "用户评价" },
        ],

        "stageList": [
            {
                "stage": "阶段一",
                "title": "HTML5 网页开发",
                "list": [
                    {
                        "l_title": "学习目标",
                        "l_ls": [
                            "正确认识前端以及前端开发在互联网中究竟属于一个怎样的工种",
                            "了解快速成为前端大神所必要的学习路径及阶段侧重点",
                            "掌握当下前沿的 Web 标准组成，了解下一步的发展趋势",
                            "掌握 HTML + CSS 配合设计软件切图，开发静态网页",
                            "通过不同的屏幕适配方案开发能够在移动端正常使用的网页",
                            "了解网站运行的原理及服务端客户端交互的过程"
                        ]
                    }, {
                        "l_title": "核心内容模块",
                        "l_ls": [
                            "HTML + CSS ｜ W3C 规范 ｜ 语义化网页开发 ｜ 基础的 SEO ｜ 盒子模型 ｜媒体查询 ｜ Flex 布局 ｜ 移动端适配 ｜ CSS 动画 ｜ 3D 效果 ｜ Bootstrap ｜ rem 等新单位 ｜ HTTP 协议"
                        ]
                    }, {
                        "l_title": "企业项目实战",
                        "l_ls": [
                            "「拉勾」PC 端页面项目",
                            "「京东商城」移动端页面项目",
                            "「苏宁易购」移动端网页项目"
                        ]
                    }
                ]
            }, {
                "stage": "阶段二",
                "title": "JavaScript 网页编程",
                "list": [
                    {
                        "l_title": "学习目标",
                        "l_ls": [
                            "掌握第一门编程语言：JavaScript",
                            "深入理解 JavaScript 的高级特性及原理",
                            "通过大量网页应用的开发锻炼提高编程能力",
                            "掌握网页开发中局部业务功能的设计及编码",
                            "能够使用 jQuery 提高网页应用开发效率",
                            "能够使用 AJAX 完成应用与服务端的数据通信"
                        ]
                    }, {
                        "l_title": "核心内容模块",
                        "l_ls": [
                            "基本的数据结构 ｜ 条件分支语句 ｜ 循环语句和应用 ｜ DOM 和 BOM 编程方法 ｜ 函数、闭包、递归 ｜ 作用域、预解析 ｜ 对象、原型、原型链 ｜ 内置对象应用 ｜ 面向对象编程 ｜ JavaScript 开发游戏 ｜ 正则表达式 ｜ ES6、ES7 新语法 ｜ jQuery 快速开发 ｜ jQuery 常用插件 ｜ jQuery 原理 ｜ AJAX 网络编程 ｜ 跨域和解决方案 ｜ Axios AJAX 库"
                        ]
                    }, {
                        "l_title": "企业项目实战",
                        "l_ls": [
                            "网页特效案例（轮播图、拖拽效果、页面滚动等）",
                            "『贪食蛇』小游戏项目 -面向对象编程运用",
                            "『网络留言板』网页应用项目  -  AJAX 快速应用开发",
                            "『网络搜索』网页应用项目  - AJAX 快速应用开发"
                        ]
                    }
                ]
            }, {
                "stage": "阶段三",
                "title": "前端工程化开发",
                "list": [
                    {
                        "l_title": "学习目标",
                        "l_ls": [
                            "能够配置前端工程化所必要的环境和工具，并理解其中关系",
                            "掌握如何借助 NPM 工具自动化的管理、维护项目依赖",
                            "掌握通过 Less/Sass、PostCSS、Babel 等工具提升编码效率，减少项目维护成本",
                            "能够使用 ESLint、StyleLint、SassLint 等工具规范项目编码，确保项目的代码质量",
                            "能够使用 Gulp/Grunt 设计一个前端自动化开发工作流，提升开发效率",
                            "了解如何针对不同类型的项目设计合理的工程化项目",
                        ]
                    }, {
                        "l_title": "核心内容模块",
                        "l_ls": [
                            "Git 分布式版本控制系统 ｜ Node.js 基础 ｜ npm / yarn 包管理工具 ｜ Less 预处理器 ｜ PostCSS 转换 CSS 工具 ｜ CSSNext ｜ Babel 编译器 ｜ ESLint 插件化 JS 代码检测工具 ｜ StyleLint CSS 代码规范工具 ｜ Prettier 代码格式化工具 ｜ 脚手架工具 ｜ npm scripts  ｜ Gulp 自动化构建工具 ｜ Grunt JS 构建工具 ｜ 模块化标准与规范 ｜ Rollup 模块打包器 ｜ Webpack 模块打包器 ｜ Webpack 5 新特性"
                        ]
                    },
                    {
                        "l_title": "企业项目实战",
                        "l_ls": [
                            "通用前端工程化项目模板",
                            "基于所学工具搭建一个可以复用的项目模板，提升以后的开发效率",
                            "『静态站点项目』工程化项目"
                        ]
                    },
                ]
            }, {
                "stage": "阶段四",
                "title": "Vue.js 框架实战及原理",
                "list": [
                    {
                        "l_title": "学习目标",
                        "l_ls": [
                            "理解数据驱动型开发与传统界面驱动型开发的差异及各自优缺点",
                            "能够掌握主流框架 Vue.js 2、Vue.js 3 的使用以及全家桶配置搭建",
                            "了解如何借助 MVVM 思想组织大型应用项目的结构",
                            "能够使用数据流管理方案解决超大型应用中数据扭转的问题",
                            "了解如何使用服务端渲染方案解决 SPA 应用的性能及 SEO 问题",
                            "理解 MVVM 框架原理，开发一个类似 Vue.js 的框架",
                        ]
                    }, {
                        "l_title": "核心内容模块",
                        "l_ls": [
                            "Vue.js 概述和应用 ｜ 插值表达式 ｜ 常用指令概念和用法 ｜ 计算属性 ｜ 双向数据绑定 ｜ 侦听器和过滤器 ｜ 事件处理 ｜ 自定义指令 ｜ Vue 的生命周期 ｜ MVVM 设计思想 ｜ defineProperty / Proxy ｜ Vue Router 路由原理 ｜ Vue CLI 脚手架 ｜ Vue Devtools 调试工具 ｜ Vue.js 组件化开发 ｜ Element UI 组件库 ｜ Vuex 状态管理工具 ｜ 前后端数据交互 ｜ JWT 接口鉴权 ｜ Vue.js 3.0  新版本 ｜ Composition APIs"
                        ]
                    },
                    {
                        "l_title": "企业项目实战",
                        "l_ls": [
                            "项目一：『拉勾教育』后台管理系统",
                            "项目二：『拉勾教育』移动端项目实战",
                            "项目三：『拉勾心选』移动电商项目"
                        ]
                    },
                ]
            }, {
                "stage": "阶段五",
                "title": "React 框架实战开发",
                "list": [
                    {
                        "l_title": "学习目标",
                        "l_ls": [
                            "理解数据驱动形开发与传统界面驱动形开发的差异及各自优缺点",
                            "能够掌握 React.js 等主流框架的使用以及全家桶配置搭建",
                            "了解如何借助 MVVM 思想组织大型应用项目的结构",
                            "能够使用数据流管理方案解决超大型应用中数据扭转的问题",
                            "了解如何使用服务端渲染方案解决 SPA 应用的性能及 SEO 问题"
                        ]
                    }, {
                        "l_title": "核心内容模块",
                        "l_ls": [
                            "React 概述和用法 ｜ JSX 语法和应用、进阶 ｜ 组件化开发思想 ｜ 组件的生命周期 ｜ 组件的内部状态处理 ｜ 模板语法 ｜ 前后端数据交互 ｜ axios 用法强化 ｜ 事件处理 ｜ 条件渲染 ｜ 列表渲染 ｜ React Router 路由的本质和原理 ｜ 路由模块基本用法 ｜ 嵌套路由、路由重定向 ｜ 移动端综合项目 ｜ 性能优化和部署上线 ｜ 服务端渲染 ｜ 性能监控 ｜ 埋点方案 ｜ 异常上报 ｜ Redux 状态管理 ｜ Mobx 状态管理 ｜ React Hooks 原理与实践"
                        ]
                    }, {
                        "l_title": "企业项目实战",
                        "l_ls": [
                            "项目一：『拉勾图书商城』后端管理平台",
                            "项目二：『拉勾图书商城』门户系统项目",
                        ]
                    }
                ]
            }, {
                "stage": "阶段六",
                "title": "小程序与移动游戏开发",
                "list": [
                    {
                        "l_title": "学习目标",
                        "l_ls": [
                            "了解微信小程序的设计理念以及与 App 有何不同",
                            "掌握如何使用前端技术开发一款自己的微信小程序",
                            "能够通过接入第三方云服务，不用服务端支持也能开发小程序",
                            "了解 Web、App、小程序、H5 等多终端统一开发解决方案",
                            "能够使用混合式开发技术开发移动 App",
                            "掌握 canvas 和 微信小游戏开发技巧",
                            "快速上手鸿蒙应用开发，掌握 JS UI 的基本语法",
                            "掌握鸿蒙前端架构的设计与原理"
                        ]
                    }, {
                        "l_title": "核心内容模块",
                        "l_ls": [
                            "开发工具使用 ｜ 小程序配置详解 ｜ 小程序 UI 开发 ｜ WXSS 样式 ｜ 小程序 API 编程 ｜ 事件处理 ｜ 生命周期 ｜ wxs 抽象 ｜ 网络编程 ｜ Taro 方案 ｜ Uni-app 框架 ｜ Canvas 画布 ｜ 微信小游戏开发 ｜鸿蒙应用开发 ｜ 鸿蒙 JS UI ｜ 鸿蒙前端架构"
                        ]
                    },
                    {
                        "l_title": "企业项目实战",
                        "l_ls": [
                            "项目一：『社区论坛』小程序项目",
                            "项目二：『本地生活』类似大众点评的小程序项目",
                            "项目三：『Flappy Bird』微信小游戏项目",
                            "项目四： 鸿蒙应用开发"
                        ]
                    }
                ]
            }, {
                "stage": "阶段七",
                "title": "Web 全栈开发",
                "list": [
                    {
                        "l_title": "学习目标",
                        "l_ls": [
                            "了解 Node.js 的定位及对前端开发行业的意义",
                            "能够通过 Node.js 完成基本的服务端应用开发",
                            "能够掌握常用中间件的使用方式",
                            "能够使用 Express 完成服务端接口的开发",
                            "能够使用 Koa 完成服务端接口的开发",
                            "能够使用 ejs 模板引擎进行动态网页处理",
                            "能够掌握 Cookie、Session 等状态保持方案",
                            "能够掌握基本的 MongoDB 数据库操作"
                        ]
                    }, {
                        "l_title": "核心内容模块",
                        "l_ls": [
                            "Node.js 基础 ｜ CommonJS 规范 ｜ Node.js 核心模块 ｜ fs 文件系统 ｜ HTTP 模块搭建 Web ｜Node.js 中的自定义模块 ｜ require 的加载机制 ｜第三方模块 ｜npm 的应用 ｜ art-template 模板引擎 ｜ 事件循环机制 ｜ IP、DNS 服务器、端口 ｜ HTTP 协议 ｜ 请求与响应 ｜ Express 快速搭建 Web ｜ 中间件介绍及分类 ｜ Express 服务端路由 ｜ 会话保持 ｜ Cookie 和 Session ｜Koa 应用和实现原理 ｜ NoSQL 数据库 ｜ MongoDB 使用 ｜Mongoose ｜接口开发"
                        ]
                    },
                    {
                        "l_title": "企业项目实战",
                        "l_ls": [
                            "『论坛』Express 接口服务开发、传统 Web 应用",
                            "『技术博客』在线技术社区（项目包含路由模块、用户模块、登陆模块、分类模块、文章模块、数据模块、中间件、接口鉴权、Token 认证、接口开发等）",
                        ]
                    }
                ]
            }, {
                "stage": "阶段八",
                "title": "协作开发与面试指导",
                "list": [
                    {
                        "l_title": "学习目标",
                        "l_ls": [
                            "掌握企业级项目开发流程，了解前端如何快速切入",
                            "了解互联网研发团队组成、职责划分以及协作模式",
                            "掌握什么是敏捷开发模式，如何通过这种模式提高产能",
                            "掌握一般我们在公司使用的团队研发管理工具",
                            "学会如何持续学习不断提升自己在职场中的竞争力",
                            "掌握 BATJ 等大厂的高频面试真题",
                            "培养面试中应具备的能力和技巧",
                            "学会打造一份优秀的、让人无法拒绝的简历"
                        ]
                    }, {
                        "l_title": "核心内容模块",
                        "l_ls": [
                            "企业级项目开发流程 ｜ 互联网研发团队协作 ｜ 敏捷开发模式 ｜ 团队管理工具 ｜ 源码管理技巧 ｜ 大厂高频面试真题解析 ｜ 面试专项能力快速提升方法 ｜ 面试技巧 ｜ 简历打造技巧"
                        ]
                    }
                ]
            }
        ]
    }
}